<template>
  <div style="height: 100%;">
    <nav class="navbar navbar-dark bg-primary bd-navbar navbar-light sticky-top navbar-expand-md">
      <div id="bd-main-nav" class="justify-content-between navbar-collapse collapse" style="display: none;">
        <b-navbar-brand href="#"><b-img :src="require('../assets/Eudoxus_Distribution_Logo_White_Gr.png')" border="2" height="40px" alt=""></b-img></b-navbar-brand>
        <a class="navbar-brand" href="#">Εφαρμογή Σημείου Διανομής</a>
        <b-button size="sm" right @click="logout" class="col-sm-auto" variant="primary">
          Αποσύνδεση
        </b-button>
      </div>
    </nav>
    <div class="container-fluid">
      <b-container>
        <!--<b-alert show style="text-align: center;" variant="danger">Για το Εαρινό Εξάμηνο 2019-2020 η διανομή των συγγραμμάτων στους δικαιούχους φοιτητές θα γίνει ταχυδρομικώς από τους εκδότες. Δεν είναι δυνατή καμία παράδοση από τα Σημεία Διανομής.</b-alert>-->
        <b-alert style="text-align: center;" id="alert" :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false" size="sm" variant="danger" dismissible>{{alertMsg}}</b-alert>
      </b-container>
      <div class="row flex-xl-nowrap2">

        <div>
          <login-component
                            @distributionPointDto="distributionInfoPanelSetUp"
                            @distributionValidDatesDto="distributionValidDatesPanelSetUp"></login-component>
        </div>

        <loading-component></loading-component>

        <div class="bd-sidebar col-md-2 col-lg-2 col-12">

          <b-card header-bg-variant="info"
                  border-variant="info"
                  header-text-variant="white"
                  style="margin-top: 10px;">
            <h6 slot="header" class="mb-0">
              <strong>Σημείο Διανομής</strong>
            </h6>
            <b-form>
              <small>
                <b-form-group>
                  <p><strong>Κωδικός Ευδόξου</strong>: {{eudoxusId}}</p>
                  <p><strong>Όνομα</strong>: {{distributionPointName}}</p>
                  <p><strong>Διεύθυνση</strong>: {{distributionPointAddress}}</p>
                  <p><strong>Τ.Κ.</strong>: {{distributionPointZipCode}}</p>
                  <p><strong>Πόλη</strong>: {{cityName}}</p>
                </b-form-group>
              </small>
            </b-form>
          </b-card>

          <b-card header-bg-variant="info"
                  border-variant="info"
                  header-text-variant="white"
                  style="margin-top: 10px;">
            <h6 slot="header"
                class="mb-0"><strong>Ημερομηνίες Παραδόσεων</strong></h6>
            <b-form>
              <small>
                <b-form-group>
                  <p><strong>Καταληκτική ημερομηνία παραδόσεων</strong>: {{startDate}}</p>
                  <p><strong>Καταληκτική ημερομηνία επιστροφών</strong>: {{endDate}}</p>
                </b-form-group>
              </small>
            </b-form>
          </b-card>
        </div>

        <div class="pb-md-1 pl-md-1 bd-content col-md-10 col-xl-10 col-12">
          <div role="group">
            <div class="container-fluid">
              <div class="bd-content">

                <distribution-points-tab-panel
                  style="margin-top: 10px;"></distribution-points-tab-panel>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import {GlobalEudoxusBus} from "../js/DistributionRequestService.js";
  import DistributionPointsTabPanel from './DistributionPointsTabPanel.vue';
  import LoginComponent from './LoginModalComponent/LoginComponent.vue';
  import LoadingComponent from './LoadingModalComponent/LoadingComponent.vue';
  import FooterComponent from './FooterComponent.vue';
  import requests from '../js/DistributionRequestService.js';


  export default {
    data() {
      return {
        eudoxusId: '',
        distributionPointName: '',
        distributionPointAddress: '',
        distributionPointZipCode: '',
        cityName: '',
        deliveryValidDate: '',
        returnValidDate: '',
        startDate: '',
        endDate: '',
        toggleLoginModal: false,
        showDismissibleAlert: false,
        alertMsg: ""
      }
    },
    components: {
      'distributionPointsTabPanel': DistributionPointsTabPanel,
      'loginComponent': LoginComponent,
      'loadingComponent': LoadingComponent,
      'footerComponent': FooterComponent
    },
    methods: {
      distributionInfoPanelSetUp(distributionDto) {
        this.eudoxusId = distributionDto.id;
        this.distributionPointName = distributionDto.distributionPointName;
        this.distributionPointAddress = distributionDto.distributionPointAddress;
        this.distributionPointZipCode = distributionDto.distributionPointZipCode;
        this.cityName = distributionDto.cityName;
      },
      distributionValidDatesPanelSetUp(distributionValidDatesDto) {
        this.startDate = distributionValidDatesDto.startDate;
        this.endDate = distributionValidDatesDto.endDate;
      },
      logout() {
        requests.logout();
      },
      attemptLogin() {
        requests.autoLogUser(this.getValidDates);
      },
      getValidDates() {
        GlobalEudoxusBus.$emit('distributionTabsLayoutSetup', requests.getDistributionType());
        requests.getDistributionValidDates();
      }
    },
    created() {
      GlobalEudoxusBus.$on('alertDialogToggle', data => {
        this.showDismissibleAlert = data.flag;
        this.alertMsg = data.msg;
      });

      this.attemptLogin();
    }
  }

</script>

<style lang="scss">
  @import '../styles/custom-bootstrap.scss';
  @import '../../node_modules/bootstrap/scss/bootstrap.scss';

  #dpCode {
    margin: 10px;
  }

  .card-body {
    padding: 1.0rem;
  }

  .row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue